import React, { useEffect, useState, useMemo, useRef } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import AssignmentStatus from "../course/AssignmentStatus";
import AssignmentType from "../course/AssignmentType";
import Swal from "sweetalert2";
import { GetSubjectAssignments, getAssignmentsFiles } from "../../services/QualificationService";
import moment from "moment-timezone";
import Str from "../common/Str";
import SkeletonTicketList from "../../loaders/SkeletonTicketList";
import { useSelector } from "react-redux";
import { BASE_URL, UPLOAD_ROOT_PATH, zipURL } from "../../utils/Constants";
import JSZip from "jszip";
import { saveAs } from "file-saver"

const ShowDuration = ({ data }) => (
  <div className="assessment-06"><p>{data.timeHour}h:{data.timeMin}m</p></div>
);

const SubjectAssignmentsLatest = ({ subjectId, parentCall, shortCourse, subjectContent }) => {
  const [loading, setLoading] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [noDataComponent, setNoDataComponent] = useState([]);
  const [renderTable, setRenderTable] = useState(false);
  const [seeMore, setSeeMore] = useState([]);
  const [files, setFiles] = useState([]);
  const [isFiles, setIsFIles]=useState(false)
  const [tab, setTab] = useState("assessments")
  const selectorState = useSelector((state) => state);
  const { user } = selectorState
  const isWithHeldStatus = localStorage.getItem("resultWithHeld");
  const [filteredAssignments, setFilteredAssignments] = useState([]);
  const [fileName, setFileName] = useState('');
  const isAssessmentDownloadBtn = useSelector(state => state.learningMaterial.isAssessmentDownloadBtn)
  const [overflowRows, setOverflowRows] = useState({});
  const contentRefs = useRef({});
  const [pageChangeTrigger, setPageChangeTrigger] = useState(0);

  const AppealButton = ({ appeal_button, row_id }) => {
    switch (appeal_button) {
      case "appeal":
        return (
          <>
            <button
              title="Appeal"
              onClick={() => viewMe(row_id, "view_appeal")}
              className="btn rounded-circle btn-danger appeal-icon-circle"
            >
              <i className="fal fa-book-reader"></i>
            </button>
          </>
        );
      case "appeal_view":
        return (
          <>
            <button
              title="View Appeal"
              onClick={() => viewMe(row_id, "view_appeal")}
              className="btn rounded-circle btn-warning"
            >
              <i className="fal fa-book-reader"></i>
            </button>
          </>
        );
      case "appeal_submit":
        return (
          <>
            <button
              title="Appeal Submitted"
              onClick={() => viewMe(row_id, "view_appeal")}
              className="btn rounded-circle btn-gray"
              disabled
            >
              <i className="fal fa-book-reader"></i>
            </button>
          </>
        );
      default:
        return (
          <>
            <button
              title="No appeal options"
              onClick={() => { }}
              className="btn rounded-circle btn-gray"
              disabled
            >
              <i className="fal fa-book-reader"></i>
            </button>
          </>
        );
    }
  };

  // Toggle expand/collapse
  const handleSeeMore = (row) => {
    const updated = [...seeMore];
    const index = updated.indexOf(row.id);

    if (index > -1) {
      updated.splice(index, 1);
    } else {
      updated.push(row.id);
    }

    setSeeMore(updated);
  };
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div data-toggle="tooltip" title={row.name} className="assessment-02">
          <p onClick={() => viewMe(row.id, "view")} className="info-text">
            <a className="curser overflow-ellipsis2 plink">{row.name}</a>
          </p>
        </div>
      ),
    },
    {
      name: "Type",
      selector: "ass_type",
      sortable: true,
      cell: (row) => <AssignmentType ass_type={row.ass_type} />,
    },
    {
      name: "Status",
      sortable: true,
      selector: "status",
      cell: (row) => <AssignmentStatus status={row.status} />,

    },
    {
      name: <div className="thead-conditions">Conditions <i data-toggle="tooltip" title="This column communicates the nature of an exam/Assessment and the conditions associated with it" className="fal fa-info-circle"></i></div>,
      selector: "conditions",
      cell: (row) => (
        <div className="table-exam-act">
          <span className="ts-info-act">
            {row.camera ? <i data-toggle="tooltip" title="This exam requires your computer/Laptop to have an operational webcam" className="fal fa-webcam active"></i> : null}
            {row.audio ? <i data-toggle="tooltip" title="This exam requires your computer/Laptop to have an operational microphone" className="fal fa-microphone"></i> : null}
            {row.screen_share ? <i data-toggle="tooltip" title="This exam will record the contents of your screen, please have one screen and disconnect secondary screens" className="fal fa-desktop"></i> : null}
            {row.timeLimitActive ? <i data-toggle="tooltip" title="This is a timed exam" className="fal fa-clock"></i> : null}
          </span>
        </div>
      ),
    },
    {
      name: "Open Date",
      selector: "open_date_time",
      sortable: true,
      omit: shortCourse,
      cell: (row) => (
        <div className="assessment-04 dateTime">
          <p className="right-space">{moment.unix(row.open_date_time).format("D MMM 'YYYY")}</p><p>{moment.unix(row.open_date_time).format("HH:mm")}</p>
        </div>
      ),
    },
    {
      name: "Close Date",
      sortable: true,
      selector: "close_date_time",
      wrap: true,
      omit: shortCourse,
      cell: (row) => (
        <div className="assessment-05 dateTime">
          <p className="right-space">{moment.unix(row.close_date_time).format("DD MMM 'YYYY")}</p><p>{moment.unix(row.close_date_time).format("HH:mm")}</p>
        </div>
      ),
    },
    {
      name: "Duration",
      selector: "timeHour",
      sortable: true,
      cell: (row) =>
        row.timeLimitActive == 1 ? <ShowDuration data={row} /> : "N/A",
    },
  {
      name: "Results",
      selector: "grade",
      sortable: false,
      minWidth: "200px",
    cell: (row) => {
        // GRADE MIX
      return (subjectContent?.grading_standard == 2) ?
        (
            (row.ass_type != "Survey"
              && row.status === "Closed-Submitted")
            ? "-"
            : (
              row.status == "Closed-Marked"
              || row.status == "Closed Not-Submitted"
            )
              && user.status != "Results Witheld"
              && isWithHeldStatus != "true"
              && row.notify_assessed == 1
              ?
              (<>
                {
                  (row?.grademixCulc || []).map((item, index) => {
                    if (index > 2 && !seeMore.includes(row.id)) {
                      return ""
                    }
                    return <div>{item.sor_name}:
                      <strong>{item?.grading_type == 3
                        ? `${item?.gradeText}/${item?.ass_total_mark}`
                        : item.gradeText}</strong>
                    </div>
                  })
                }
                {
                  row?.grademixCulc?.length
                    && (row?.grademixCulc?.length > 3)
                    ? <span className="table-see-more" onClick={() => handleSeeMore(row)}>See {seeMore.includes(row.id)
                      ? "Less"
                      : "More"}...</span>
                    : ""
                }
              </>)
              : user.status == "Results Witheld" && isWithHeldStatus == "true"
                ? <span className="witheld-status">WITHHELD</span>
                : "-"
        )
        // NOT GRADE MIX"
        // Only show results if conditions are met
        : (row.ass_type != "Survey" ?
          (row.status === "Closed-Submitted" ? "-" : (row.status == "Closed-Marked" || row.status == "Closed Not-Submitted") && user.status != "Results Witheld" && isWithHeldStatus != "true" && row.notify_assessed == 1 ? <>
            <div
              ref={(el) => (contentRefs.current[row.id] = el)}
              style={{
                maxHeight: seeMore.includes(row.id) ? "none" : "3em",
                overflow: "hidden",
                whiteSpace: "normal",
                lineHeight: "1.5em",
              }}

            >
              {(row?.assignedCourses || []).filter((d, i) => row?.studentCourses?.find(data => data.intake == d.intake)?.grading_type != "4").map((item, index) => (
                <div key={index}>
                  <span>{item?.courseName}&nbsp;:&nbsp;</span>
                  <strong>
                    {(row?.studentCourses?.find(d => d.intake == item.id))?.grading_type == 3
                      ? `${parseFloat(parseFloat(row?.studentCourses?.find(d => d.intake == item.id)?.gradeText)?.toFixed(2))}/${(row?.studentCourses?.find(d => d.intake == item.id))?.ass_total_mark}`
                      : (row?.studentCourses?.find(d => d.intake == item.id))?.gradeText}
                  </strong>
                </div>
              ))}
            </div>


            {overflowRows[row.id] && (
              <span
                className="table-see-more plink"
                title={seeMore.includes(row.id) ? "See Less" : "See More"}
                onClick={() => handleSeeMore(row)}
              >
                See {seeMore.includes(row.id) ? "Less" : "More"}...
              </span>
            )}
          </> : user.status == "Results Witheld" && isWithHeldStatus == "true" ? <span className="witheld-status">WITHHELD</span> : "-")
          : "-")
      }
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="assessment-08 d-flex">
          <div className="as-buttons">
            <button
              title="Open"
              className="btn btn-primary rounded-circle"
              onClick={() => viewMe(row.id, "view")}
            >
              <i className="fal fa-folder-open"></i>
            </button>
          </div>
          {shortCourse ? null : <div className="as-buttons">
            <AppealButton appeal_button={row.appeal_button} row_id={row.id} />
          </div>}

        </div>
      ),
    },
  ]);

  const [status, setStatus] = useState([])
  const [searchStatusCheck, setSearchStatusCheck] = useState({
    "action8": false,
    "action9": false,
    "action10": false,
    "action11": false,
    "action12": false,
    "action13": false,
    "action14": false,
  })
  const [searchType, setSearchType] = useState([])
  const [searchTypeCheck, setSearchTypeCheck] = useState({
    "action1": false,
    "action2": false,
    "action3": false,
    "action4": false,
    "action5": false,
    "action6": false,
    "action7": false,
    "action9": false,
    "action10": false,
    "action15": false,
    "action16": false,
    "action17": false
  })
  const [search, setSearch] = useState("");
  //cleaning assessment file object
  useEffect(()=>{
    setFiles([])
    setFiles(false)
  },[])

  const dataToRender = () => {
    let updatedData = []
    let allData = filteredAssignments
    if (search.length) {
      let tempName = allData.filter(item => {
        let includes = item.name.toLowerCase().includes(search.toLowerCase())
        if (includes) {
          return includes
        } else return null
      })
      let tempType = allData.filter(item => {
        let includes = item.ass_type && item.ass_type.toLowerCase().includes(search.toLowerCase())
        if (includes) {
          return includes
        } else return null
      })
      let tempStatus = allData.filter(item => {
        let includes = item.status && item.status.toLowerCase().includes(search.toLowerCase())
        if (includes) {
          return includes
        } else return null
      })
      let tempOpenDate = allData.filter(item => {
        let includes = item.open_date_time && (moment.unix(item.open_date_time).format("D MMM 'YY HH:mm a").toLowerCase().includes(search.toLowerCase()))
        if (includes) {
          return includes
        } else return null
      })
      let tempCloseDate = allData.filter(item => {
        let includes = item.close_date_time && (moment.unix(item.close_date_time).format("D MMM 'YY HH:mm a").toLowerCase().includes(search.toLowerCase()))
        if (includes) {
          return includes
        } else return null
      })

      let data = [...tempName, ...tempType, ...tempStatus, ...tempOpenDate, ...tempCloseDate]
      let unique = [...new Set(data)]

      updatedData = unique
    } else {
      updatedData = allData
    }

    if (searchType.length) {
      let tempStatus = updatedData
      let tempSearch = tempStatus.filter(item => {
        let tempItem = item.ass_type ? item.ass_type.toLowerCase() : ''
        var tempItemNew = tempItem ? tempItem.replace(/-/g, ' ') : tempItem;
        const startsWith = searchType.find(function (post, index) {
          let tempPost = post ? post.toLowerCase() : ''
          var tempPostNew = tempPost ? tempPost.replace(/-/g, ' ') : tempPost;
          if (tempPostNew == tempItemNew)
            return item;
        });
        if (startsWith) {
          return startsWith
        } else return null
      })
      updatedData = tempSearch
    }

    if (status.length) {
      let tempStatus = updatedData
      let tempSearch = tempStatus.filter(item => {
        let tempItem = item.status ? item.status.toLowerCase() : ''
        var tempItemNew = tempItem ? tempItem.replace(/-/g, ' ') : tempItem;
        const startsWith = status.find(function (post, index) {
          let tempPost = post ? post.toLowerCase() : post
          var tempPostNew = tempPost ? tempPost.replace(/-/g, ' ') : tempPost;
          if (tempPostNew == tempItemNew)
            return item;
        });
        if (startsWith) {
          return startsWith
        } else return null
      })
      updatedData = tempSearch
    }
    if (status.length || searchType.length || search.length) {
      return updatedData
    } else {
      return filteredAssignments
    }
  }

  // ** Function to handle status filter  
  const handleStatusFilter = e => {
    const value = e.target.value
    let arr = status;

    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setStatus(arr)
    let id = e.target.id;
    setSearchStatusCheck({ ...searchStatusCheck, [id]: !searchStatusCheck[id] });
  }

  useEffect(() => {
    let isSubscribed = true;
  
    let filteredAssignments;

    switch (tab) {
      case "upcoming":
        filteredAssignments = assignments.filter(
          (item) =>
            item.status !== "Closed Not-Submitted" && // Exclude "Closed Not-Submitted" items
            moment(item.close_date_time * 1000).isSameOrAfter(moment().startOf('day')) // Compare close time with the start of today
        );
        break;

      case "past":
        filteredAssignments = assignments.filter(
          (item) =>
            item.status === "Closed Not-Submitted" && // Include only "Closed Not-Submitted" items
          moment(item.close_date_time * 1000).isBefore(moment())// Compare close time with the start of today
        );
        break;

      case "marked":
        filteredAssignments = assignments.filter(
          (item) => item.notify_assessed === 1
        );
        break;

      default:
        filteredAssignments = assignments; // Default to showing all assignments
        break;
      }
    if (isSubscribed) {
      setFilteredAssignments(filteredAssignments);
    }

    return () => {
      isSubscribed = false;
    }
  }, [tab, assignments]);
  
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      setFilteredAssignments(assignments)
    }
    return () => {
      isSubscribed = false;
    }
  }, []);

  // ** Function to handle type filter  
  const handleTypeFilter = e => {
    const value = e.target.value
    let arr = searchType;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setSearchType(arr);
    let id = e.target.id;
    setSearchTypeCheck({ ...searchTypeCheck, [id]: !searchTypeCheck[id] });
  }

  // ** Function to handle type filter  
  const handleSearchFilter = e => {
    const value = e.target.value;
    setSearch(value);
  }

  const handleAttachment=()=> {
    getAssignmentsFiles({ sid: subjectId })
      .then((res) => {
        if (res.status == 200) {
          setFiles(res.data?.AssignmentsFiles)
          setFileName(res.data?.courseName)
          setIsFIles(true)
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Download Failed",
        });
      });
  }

  useEffect(() => {
    let isSubscribed = true;
    const downloadFile = async (url) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
  
        xhr.onload = function() {
          if (this.status === 200 && isSubscribed) {
            resolve(xhr.response);
          } else {
            reject(new Error(`Download failed with status ${this.status}`));
          }
        };
  
        xhr.onerror = function() {
          if (isSubscribed) {
            reject(new Error('Network error occurred'));
          }
        };
  
        xhr.send();
      });
    };
  
    const downloadAllFiles = async () => {
      const zip = new JSZip();
      const newArr = files || [];
  
      if (newArr.length) {
        if (!isSubscribed) return;
        Swal.fire({
          title: "Creating ZIP",
          text: "Please wait while we create the ZIP file...",
          icon: "info",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
  
      try {
        if (!isSubscribed) return;
        await Promise.all(
          newArr.map(async (data) => {
            if (!isSubscribed) return;
            if (data?.submission_files?.length || data?.feedback_files?.length) {
              const assignmentFolder = zip.folder(data?.assignmentsName.replace(/\//g, ' '));
              let hasFiles = false;
              // Download Submission Files
              if (data?.submission_files?.length) {
                let submissionFolder = assignmentFolder?.folder("Submission Files");
                let submissionHasFiles = false;
                await Promise.all(
                  data?.submission_files.map(async (file) => {
                    if (!isSubscribed) return;
                    const fileURL = file?.relativePath?.startsWith("http")
                      ? file?.relativePath
                      : `${zipURL}${BASE_URL.replace("https://","")}/${file?.relativePath
                          .replaceAll(`${UPLOAD_ROOT_PATH}/`, "")
                          .replace("public/", "")
                          .replace("null/", "")}`;
                    
                    const fileExt = file?.relativePath?.split("/").reverse()[0];
  
                    try {
                      const blob = await downloadFile(fileURL);
                      submissionFolder.file(fileExt, blob, { binary: true });
                      submissionHasFiles = true; 
                      hasFiles = true;
                    } catch (err) {
                      console.error(`Error downloading submission file: ${fileExt}`, err);
                    }
                  })
                );
                if (!submissionHasFiles) {
                  zip.remove(`${data?.assignmentsName.replace(/\//g, ' ')}/Submission Files`); 
                }
              }
  
             // Download feedback Files
              if (data?.feedback_files?.length && isSubscribed) {
                let feedbackFolder = assignmentFolder.folder("Feedback Files");
                let feedbackHasFiles = false;
                await Promise.all(
                  data?.feedback_files?.map(async (file) => {
                    if (!isSubscribed) return;
                    const fileURL = file?.relativePath?.startsWith("http")
                      ? file?.relativePath
                      : `${zipURL}${BASE_URL.replace("https://","")}/${file?.relativePath
                        .replaceAll(`${UPLOAD_ROOT_PATH}/`, "")
                          .replace("public/", "")
                          .replace("null/", "")}`;
                    
                    const fileExt = file?.relativePath?.split("/").reverse()[0];
  
                    try {
                      const blob = await downloadFile(fileURL);
                      feedbackFolder.file(fileExt, blob, { binary: true });
                      feedbackHasFiles = true;
                      hasFiles = true;
                    } catch (err) {
                      console.error(`Error downloading submission file: ${fileExt}`, err);
                    }
                  })
                );
                if (!feedbackHasFiles) {
                  zip.remove(`${data?.assignmentsName.replace(/\//g, ' ')}/Feedback Files`); // Prevent folder creation if no valid files
                }
              }
              if (!hasFiles) {
                zip.remove(data?.assignmentsName); 
              }
            }
          })
        );
        if (!isSubscribed) return;
        // Check if the ZIP is empty
        if (Object.keys(zip.files).length === 0) {
          Swal.fire({
            icon: "error",
            title: "No valid files to download",
            text: "All files are invalid or missing.",
          });
          return; // Exit without creating a ZIP
        }
  
        // Generate and save ZIP
        const content = await zip.generateAsync({ type: "blob" });
        if (isSubscribed) {
          saveAs(content, `${fileName}.zip`);
          setIsFIles(false);
          Swal.fire({
            icon: "success",
            title: "Downloading Finished",
          confirmButtonText: "OK",
          });
        }
      } catch (err) {
        if (isSubscribed) {
          setIsFIles(false);
          console.error("Error processing attachments:", err);
          Swal.fire({
            icon: "error",
            title: "Download Failed",
            text: err.message,
          });
        }
      }
    };
  
    if (isFiles) {
      if (files?.length > 0) {
        downloadAllFiles();
      } else {
        if (isSubscribed) {
          setIsFIles(false)
          Swal.fire({
            icon: "error",
            title: "No assignments to download.",
          });
        }
      }
    }
    return () => {
      isSubscribed = false;
    };
  }, [files, isFiles]);

  useEffect(() => {
    let isSubscribed = true;
    setLoading(true)
    let mounted = true;
    GetSubjectAssignments({ sid: subjectId })
      .then((res) => {
        if (mounted) {
          if (!isSubscribed) return;
          const finalData = res.data.map(item => {
            if (item.status == "Closed-Marked" && item.notify_assessed == 0) {
              item.status = "Closed-Submitted";
            }
            return item;
          })

          const allFiles = finalData.reduce((acc, attachment) => {
            if (attachment?.Files && Array.isArray(attachment.Files)) {
              return [...acc, ...attachment.Files];
            }
            return acc;
          }, []);
          setFiles(allFiles);
          setAssignments(finalData);
        }
        if (res && res.data && res.data.length == 0) {
          setNoDataComponent(Str.noRecord)
        }
        setRenderTable(true)
        if (isSubscribed) {
          setTimeout(() => {
            setLoading(false)
          }, 3000);
        }
      }).catch((error) => {
        if (isSubscribed) {
          setTimeout(() => {
            setLoading(false)
          }, 3000);
        }
      });

    return () => {
      isSubscribed = false;
    };
  }, [subjectId]);

  const viewMe = (id, view) => {
    parentCall(id, view);
  };

  const resetFilter = () => {
    setSearchType([]);
    setSearchTypeCheck({
      "action1": false,
      "action2": false,
      "action3": false,
      "action4": false,
      "action5": false,
      "action6": false,
      "action7": false,
      "action9": false,
      "action10": false,
      "action15": false,
      "action16": false,
      "action17": false
    });
    setStatus([]);
    setSearchStatusCheck({
      "action8": false,
      "action9": false,
      "action10": false,
      "action11": false,
      "action12": false,
      "action13": false,
      "action14": false,
    });
    setSearch('')
  };

  //checking overflow rows for see more functionality
  useEffect(() => {
    const newOverflowRows = {};

    setTimeout(() => {
      Object.entries(contentRefs.current).forEach(([rowId, el]) => {
        if (!el) return;

        const computed = window.getComputedStyle(el);
        const lineHeight = parseFloat(computed.lineHeight) || 16;
        const maxLines = 2;
        const maxAllowedHeight = lineHeight * maxLines;

        // Compare actual height vs maxHeight (2 lines)
        if (el.scrollHeight > maxAllowedHeight + 1) {
          newOverflowRows[rowId] = true;
        }
      });

      setOverflowRows(newOverflowRows);
    }, 100);
  }, [subjectId, filteredAssignments, pageChangeTrigger, status, searchStatusCheck, searchTypeCheck, search, tab]);

  return (
    <>
      <div className="custom-table-div custom-table-div2 filter-search-icon card card-table-custom">

        <div className="top-bar-head-sec assessment__container__main">
          <div className="d-flex align-items-center assessment__head__container">
            <div className="assessment-table-heading">
              Assessments
            </div>
            <div className="lecture-tabs-wrap assessment__tab__container">
              <ul className="nav nav-pills course-nav-sticky assessment__filter__tabs" id="pills-tab" role="tablist" style={{ border: "none", marginLeft: "25px" }}>
                <li className="nav-item " title="Overview" onClick={() => setTab("upcoming")}>
                  <span className={`nav-link assessment-tab-item ${tab == "upcoming" ? "active" : ""}`}>
                    <i className="fal fa-calendar-days"></i>
                    Upcoming
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("past")}>
                  <span className={`nav-link assessment-tab-item ${tab == "past" ? "active" : ""}`}>
                    <i className="fal fa-history"></i>
                    Past
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("marked")}>
                  <span className={`nav-link assessment-tab-item ${tab == "marked" ? "active" : ""}`}>
                    <i className="fal fa-clipboard-check"></i>
                    Marked
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("assessments")}>
                  <span className={`nav-link assessment-tab-item ${tab == "assessments" ? "active" : ""}`}>
                    <i className="fal fa-ballot-check"></i>
                    All Assessments
                  </span>
                </li>
              </ul>
            </div>
           {isAssessmentDownloadBtn ?<div className="download__assesment__section">
            <button
              title="Download All"
              className={`btn btn-white-bordered download-assess`}
              onClick={() => handleAttachment()}
            >
              <i className="fal fa-arrow-to-bottom"></i>Download All
            </button>
          </div>: null} 
          </div>
          <div className="data-table-extensions assessment__filter__container p-0" style={{gap:"50px"}}>
            <div className="data-table-extensions-filter" style={{ top: "auto", display: "flex", }}>
              <label htmlFor="filterDataTable" className="icon"></label>
              <input
                type="text"
                name="filterDataTable"
                className="filter-text"
                placeholder="Search"
                onChange={handleSearchFilter}
                value={search}
              />
              <div className="filter-eff filter-data-btn">
                <button className="filter-buttons">
                  <i className="fal fa-filter"></i>
                </button>
              </div>
            </div>
              <div className="filter-button-group assessment__filter__group m-0 ">                
                <div className="assessment-table-filter filter__assessments">
                  <div className="btn-type-filter dropdown-comman">
                    <div className="dropdown multiselect">
                      <button
                        className={`btn btn-default dropdown-toggle ${searchType.length ? 'btn-selected' : ''}`}
                        type="button"
                        id="typeBtnId"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="false"
                        title="Type"
                      >
                        <span>
                          Type <i className="fal fa-angle-down"></i>
                        </span>
                      </button>
                      <form className="dropdown-menu remove-list-style">
                        <ul aria-labelledby="typeBtnId">
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action1"
                              onChange={() => {}}
                              onClick={handleTypeFilter}
                              value="Assignment"
                              checked={searchTypeCheck.action1}
                            />
                            <label htmlFor="action1">
                              <i className="fal fa-file"></i> Assignment
                            </label>
                          </li>
                          <li className="item-text-green">
                            <input
                              type="checkbox"
                              id="action2"
                              onChange={() => {}}
                              onClick={handleTypeFilter}
                              value="Internal Exam"
                              checked={searchTypeCheck.action2}
                            />
                            <label htmlFor="action2">
                              <i className="fal fa-file"></i> Internal Exam
                            </label>
                          </li>
                          <li className="item-text-yellow">
                            <input
                              type="checkbox"
                              id="action3"
                              onChange={() => {}}
                              onClick={handleTypeFilter}
                              value="External Exam"
                              checked={searchTypeCheck.action3}
                            />
                            <label htmlFor="action3">
                              <i className="fal fa-university"></i> External Exam
                            </label>
                          </li>
                          <li className="item-text-purple">
                            <input
                              type="checkbox"
                              id="action4"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="Test"
                              checked={searchTypeCheck.action4}
                            />
                            <label htmlFor="action4">
                              <i className="fal fa-file"></i> Test
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action5"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="PoE-Formative"
                              checked={searchTypeCheck.action5}
                            />
                            <label htmlFor="action5">
                              <i className="fal fa-folder-tree"></i> PoE-Formative
                            </label>
                          </li>
                          <li className="item-text-green">
                            <input
                              type="checkbox"
                              id="action6"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="PoE-Summative"
                              checked={searchTypeCheck.action6}
                            />
                            <label htmlFor="action6">
                              <i className="fal fa-folder-tree"></i> PoE-Summative
                            </label>
                          </li>
                          <li className="item-text-purple">
                            <input
                              type="checkbox"
                              id="action7"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="PoE-Informal Activities"
                              checked={searchTypeCheck.action7}
                            />
                            <label htmlFor="action7">
                              <i className="fal fa-folder-tree"></i> PoE-Informal Activities
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action15"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="Survey"
                              checked={searchTypeCheck.action15}
                            />
                            <label htmlFor="action15">
                              <i className="fal fa-file"></i> Survey
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action16"
                              onClick={handleTypeFilter}
                              onChange={() => {}}
                              value="Sick Test"
                              checked={searchTypeCheck.action16}
                            />
                            <label htmlFor="action16">
                              <i className="fal fa-file"></i> Sick Test
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action17"
                              onChange={() => {}}
                              onClick={handleTypeFilter}
                              value="Supplementary Exam"
                              checked={searchTypeCheck.action17}
                            />
                            <label htmlFor="action17">
                              <i className="fal fa-file"></i> Supplementary Exam
                            </label>
                          </li>
                        </ul>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="assessment-table-status">
                  <div className="btn-type-Status dropdown-comman">
                    <div className="dropdown multiselect">
                      <button
                        className={`btn btn-default dropdown-toggle ${status.length ? 'btn-selected' : ''}`}
                        type="button"
                        id="dropdownMenu1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                        title="Status"
                      >
                        <span>
                          Status <i className="fal fa-angle-down"></i>
                        </span>
                      </button>
                      <form className="dropdown-menu remove-list-style">
                        <ul aria-labelledby="dropdownMenu1">
                          <li className="item-text-red">
                            <input
                              type="checkbox"
                              id="action8"
                              value="Closed Not-Submitted"
                              onClick={handleStatusFilter}
                              onChange={() => {}}
                              checked={searchStatusCheck.action8}
                            />
                            <label htmlFor="action8">
                              <span className="as-red-bg as-widget">CLOSED NOT-SUBMITTED</span>
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action9"
                              onClick={handleStatusFilter}
                              value="Closed-Marked"
                              checked={searchStatusCheck.action9}
                            />
                            <label htmlFor="action9">
                              <span className="as-blue-bg as-widget">CLOSED-MARKED</span>
                            </label>
                          </li>
                          <li className="item-text-yellow">
                            <input
                              type="checkbox"
                              id="action10"
                              onClick={handleStatusFilter}
                              onChange={() => {}}
                              value="Closed-Submitted"
                              checked={searchStatusCheck.action10}
                            />
                            <label htmlFor="action10">
                              <span className="as-yellow-bg as-widget">CLOSED-SUBMITTED</span>
                            </label>
                          </li>
                          <li className="item-text-green">
                            <input
                              type="checkbox"
                              id="action11"
                              onClick={handleStatusFilter}
                              onChange={() => {}}
                              value="Submitted"
                              checked={searchStatusCheck.action11}
                            />
                            <label htmlFor="action11">
                              <span className="as-green-bg as-widget">SUBMITTED</span>

                            </label>
                          </li>
                          <li className="item-text-yellow">
                            <input
                              type="checkbox"
                              id="action12"
                              onClick={handleStatusFilter}
                              onChange={() => {}}
                              value="Pending"
                              checked={searchStatusCheck.action12}
                            />
                            <label htmlFor="action12">
                              <span className="as-yellow-bg as-widget">PENDING</span>

                            </label>
                          </li>
                          <li className="item-text-green">
                            <input
                              type="checkbox"
                              id="action13"
                              onClick={handleStatusFilter}
                              value="Draft"
                              onChange={() => {}}
                              checked={searchStatusCheck.action13}
                            />
                            <label htmlFor="action13">
                              <span className="as-green-bg as-widget">DRAFT</span>
                            </label>
                          </li>
                          <li className="item-text-blue">
                            <input
                              type="checkbox"
                              id="action14"
                              onClick={handleStatusFilter}
                              onChange={() => {}}
                              value="Open"
                              checked={searchStatusCheck.action14}
                            />
                            <label htmlFor="action14">
                              <span className="as-blue-bg as-widget">OPEN</span>
                            </label>
                          </li>
                        </ul>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="button-reset">
                  <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                    <i className="fal fa-redo"></i>Reset
                  </button>
                </div>
              </div>
          </div>
        </div>

        {!renderTable && <SkeletonTicketList />}
        {renderTable &&
          <DataTable
            title="Assessments"
            columns={columns}
            data={dataToRender()}
            pagination={true}
            noDataComponent={noDataComponent}
            defaultSortField="close_date_time"
            defaultSortAsc={false}
            onChangePage={() => setPageChangeTrigger((prev) => prev + 1)}
          />
        }
      </div>
    </>
  );
};
export default SubjectAssignmentsLatest;
